import Footer from "../components/Footer"
import "../styles/LEHYVE.css"

export default function LEHYVE() {
  return (
    <div className="lehyve-page">
      <div className="hero">
        <img className="hero-bg" src="/Assets/photo-accueil.png" alt="Coach en entraînement" />

        <div className="hero-logo">
          <img src="/Assets/logo_hyve.png" alt="Logo Le Hyve" />
        </div>
      </div>

      <div className="content">
        <div className="text">
          <h1>L’HISTOIRE</h1>
          <p>
            Hyve est né d’un constat simple :<br/> 
             <strong>Le sport mérite mieux que l’à-peu-près.</strong>
            <br/> <br/>
            À l’origine, il y a l’envie de créer un studio où l’on s’entraîne avec exigence, précision et sens. <br/> 
            Un lieu où chaque séance est pensée, structurée et utile.Pas pour faire transpirer au hasard, mais pour faire progresser durablement.<br/>
              <br/> 
            Très vite, une évidence s’impose :
            <br/><br/>
            Si l’exigence est au cœur du studio, elle doit aussi l’être dans la formation. C’est ainsi qu’est née <strong>Le Hyve Academy</strong>.<br/><br/>
            Non pas pour former plus de coachs, mais pour former de meilleurs coachs. Ici, la formation ne s’arrête pas à l’obtention d’un diplôme. Elle prépare à la réalité du métier :<strong> encadrer, structurer, s’adapter, performer </strong> dans un studio réel.<br/>
            Le Hyve, comme Le Hyve Academy, suit une seule ligne directrice : <br/> <br/>
            <strong>faire les choses sérieusement, former avec exigence, et élever les standards du training.</strong>  
            <br/><br/>
            Parce qu’au final, bien s’entraîner, comme bien coacher,ça ne s’improvise pas.
             
          </p>
          
        </div>
        <div className="presentation-image">
          <img src="/Assets/lehyve2.png" alt="Coach en session" />
        </div>

      <h1 className="slogan">
  <span>Excellence opérationnelle</span>
  <span>Authenticité</span>
  <span>Exigence bienveillante</span>
</h1>
      </div>



     
     <div className="endpage">
  <img src="/Assets/lehyve3.png" alt="Détail d'une séance d'entraînement" />

  <p className="endpage__quote">
    "Ici, on ne parle pas de sport.<br />
    On vous apprend à le faire vivre."
  </p>

  <div className="endpage__cta">
    <h2>Deviens coach<br />professionnel</h2>
    <a href="/inscription" className="endpage__btn">Je m'inscris</a>
  </div>
</div>

      <Footer backgroundColor="black" />
    </div>
  );
}